// extracted by mini-css-extract-plugin
export default {"AudioVideo":"dQN9E","inViewer":"SNZ3r","isVideo":"IoUW4","audio":"tMIQx","video":"Y3Sjw","loaded":"bt_29","loading":"WA6bh","error":"xH6bE"};